import { all } from "redux-saga/effects";
import watchAuthSaga from "./auth/saga";
// Import các sagas của bạn ở đây
// import someSaga from './someSaga';

export default function* rootSaga() {
  yield all([watchAuthSaga()]);
}
